import React, { Component } from "react"

export default class Makhanik extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Makanak Khalee</p>
            <p className="portdesctext">Short film I shot in Hi8 of my living space in Basel, Switzerland. Edited and Composited in Primere Pro & animations hand drawn in Photoshop. Abstract <a href="https://www.dropbox.com/s/oc6udhsb0y11t9t/MAKANAK_KHALEE.pdf?dl=0" target="_blank" rel="noopener noreferrer">here</a>.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.dropbox.com/s/91idp2wfuociekq/MAKANAK_KHALEE_AliRazzak_120421.mp4?dl=0" target="_blank" rel="noopener noreferrer"><p className="linktext">Video</p></a>
        </div>
      </div>
  )
}
}

